import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [company, setCompany] = useState({});
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const loadData = () => {
    fetch("/api/invoices").then(r=>r.json()).then(d=> { let arr = Array.isArray(d) ? d : []; arr.sort((a,b) => parseInt(b.invoice_no || 0) - parseInt(a.invoice_no || 0)); setInvoices(arr); });
  };

  useEffect(() => {
    loadData();
    fetch("/api/customers").then(r=>r.json()).then(d=>setCustomers(Array.isArray(d)?d:[]));
    fetch("/api/company").then(r=>r.json()).then(d=>setCompany(d||{}));
    fetch("/api/products").then(r=>r.json()).then(d=>setProducts(Array.isArray(d)?d:[]));
  }, []);

  const handleDelete = async (id) => {
    if(window.confirm("Are you sure you want to delete this invoice?")) {
      await fetch(`/api/invoices/${id}`, { method: 'DELETE' });
      loadData();
    }
  };

  const numberToWords = (num) => {
    const a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    const b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim();
  };

  const handlePrint = (inv) => {
    const customer = customers.find(c => c.id == inv.customer_id) || {};
    const isSameState = (company.state_code || "08") === (customer.state_code || "08");
    const items = inv.items || [];
    
    let totalBase = 0, totalCGST = 0, totalSGST = 0, totalIGST = 0;
    items.forEach(it => {
      const base = it.qty * it.rate;
      totalBase += base;
      const taxAmt = base * (((it.tax_rate === 0 || it.tax_rate === "0") ? 0 : (Number(it.tax_rate) || 18)) / 100);
      if (isSameState) { totalCGST += taxAmt/2; totalSGST += taxAmt/2; } else { totalIGST += taxAmt; }
    });
    const grandTotal = Math.round(totalBase + totalCGST + totalSGST + totalIGST);
    
    let invDateStr = inv.date;
    if(invDateStr && invDateStr.includes('-')) {
        invDateStr = invDateStr.split('-').reverse().join('/'); // Converts YYYY-MM-DD to DD/MM/YYYY
    }
    
    // Address fix: Aggar manual chota address hai to poora dikhao
    let compAddr = company.address || "";
    if (!compAddr || compAddr.trim().toLowerCase() === "jaipur, rajasthan") {
        compAddr = "House No. 14, Block A 2, Chinab Apartment,<br/>Sector 28, Pratap Nagar, Jaipur-302033";
    } else {
        compAddr = compAddr.replace(/\n/g, '<br/>');
    }

    const printWin = window.open('', '_blank');
    const html = `
    <html>
    <head>
      <title>Invoice - ${inv.invoice_no}</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
        @media print { body { -webkit-print-color-adjust: exact; margin: 0; padding: 10mm; } @page { size: A4; margin: 0mm; } }
        body { font-family: 'Open Sans', sans-serif; font-size: 11px; color: #000; margin: 0; padding: 10px; }
        .invoice-box { border: 1px solid #000; width: 100%; max-width: 800px; margin: 0 auto; }
        .text-center { text-align: center; } .text-right { text-align: right; }
        .font-bold { font-weight: 700; } .uppercase { text-transform: uppercase; }
        table { width: 100%; border-collapse: collapse; } tr { page-break-inside: avoid; }
        td, th { border: 1px solid #000; padding: 2px 4px; vertical-align: top; }
        .no-border-bottom { border-bottom: none !important; } 
        .no-border-top { border-top: none !important; } 
        .v-border-only { border-top: none !important; border-bottom: none !important; }
      </style>
    </head>
    <body>
       <div class="text-center font-bold" style="font-size: 16px; margin-bottom: 5px;">${(totalCGST + totalSGST + totalIGST) === 0 ? "BILL OF SUPPLY" : "TAX INVOICE"}</div>
       <div class="invoice-box">
          <table>
             <tr>
                <td style="width: 50%; padding: 8px;">
                   <div class="font-bold uppercase" style="font-size: 14px;">${company.name || 'DIGITAL SMART TECHNOLOGY'}</div>
                   <div>${compAddr}</div>
                   <div style="margin-top: 5px;">GSTIN/UIN: <strong>${company.gstin || '08AAZFD1290J1ZV'}</strong></div>
                   <div>State Name : ${company.state_name || 'Rajasthan'}, Code : ${company.state_code || '08'}</div>
                   <div style="margin-top: 5px;">PAN No. : <strong>${company.pan || 'AAZFD1290J'}</strong></div>
                   <div>E-Mail : ${company.email || 'sales@digitalsmarttechnology.com'}</div>
                   <div>Contact No. : ${company.phone || '8107044926'}</div>
                </td>
                <td style="width: 50%; padding: 0;">
                   <table>
                      <tr>
                         <td style="width: 50%; border-top: 0; border-left: 0;">Invoice No.<br/><strong style="font-size: 13px;">${inv.invoice_no}</strong></td>
                         <td style="width: 50%; border-top: 0; border-right: 0;">Dated<br/><strong style="font-size: 13px;">${invDateStr}</strong></td>
                      </tr>
                      <tr>
                         <td style="border-left: 0;">Delivery Note<br/><strong>-</strong></td>
                         <td style="border-right: 0;">Mode/Terms of Payment<br/><strong>${inv.paymentTerms || '-'}</strong></td>
                      </tr>
                   </table>
                </td>
             </tr>
             <tr>
                <td style="padding: 8px;">
                   <div>Consignee (Ship to) & Buyer (Bill to)</div>
                   <div class="font-bold uppercase" style="font-size: 13px;">${customer.name || ''}</div>
                   <div>${customer.address || ''}</div>
                   <div>GSTIN/UIN &nbsp;&nbsp;&nbsp;&nbsp;: <strong>${customer.gstin || ''}</strong></div>
                   <div>State Code &nbsp;&nbsp;&nbsp;&nbsp;: ${customer.state_code || ''}</div>
                </td>
                <td style="padding: 8px;">
                   <div>Terms of Delivery</div>
                   <div style="margin-top: 5px;">-</div>
                </td>
             </tr>
          </table>

          <table>
             <tr class="text-center" style="background-color: #f9f9f9;">
                <td style="width: 5%;">Sl<br/>No.</td><td style="width: 45%;">Particulars</td><td style="width: 10%;">HSN/SAC</td><td style="width: 8%;">Quantity</td><td style="width: 12%;">Rate</td><td style="width: 5%;">per</td><td style="width: 15%;">Amount</td>
             </tr>
             ${items.map((it, i) => {
                 const pName = products.find(p=>p.id==it.product_id)?.name || "Service Charges";
                 const baseAmt = it.qty * it.rate;
                 const taxRate = (it.tax_rate === 0 || it.tax_rate === "0") ? 0 : (Number(it.tax_rate) || 18);
                 let taxRows = "";
                 
                 if (taxRate === 0) {
                     taxRows = "";
                 } else if(isSameState) {
                     const splitTax = taxRate / 2;
                     const splitAmt = (baseAmt * (splitTax / 100)).toFixed(2);
                     taxRows = `
                        <tr><td class="v-border-only"></td><td class="text-right font-bold v-border-only">SGST</td><td class="v-border-only"></td><td class="v-border-only"></td><td class="text-center v-border-only">${splitTax}</td><td class="text-center v-border-only">%</td><td class="text-right v-border-only">${splitAmt}</td></tr>
                        <tr><td class="v-border-only"></td><td class="text-right font-bold v-border-only">CGST</td><td class="v-border-only"></td><td class="v-border-only"></td><td class="text-center v-border-only">${splitTax}</td><td class="text-center v-border-only">%</td><td class="text-right v-border-only">${splitAmt}</td></tr>
                     `;
                 } else {
                     const igstAmt = (baseAmt * (taxRate / 100)).toFixed(2);
                     taxRows = `<tr><td class="v-border-only"></td><td class="text-right font-bold v-border-only">IGST</td><td class="v-border-only"></td><td class="v-border-only"></td><td class="text-center v-border-only">${taxRate}</td><td class="text-center v-border-only">%</td><td class="text-right v-border-only">${igstAmt}</td></tr>`;
                 }
                 return `
                 <tr>
                    <td class="text-center no-border-bottom">${i+1}</td>
                    <td class="no-border-bottom font-bold">${pName} <div style="font-weight: normal; font-style: italic;">IT Services</div></td>
                    <td class="text-center no-border-bottom">${it.hsn || '-'}</td>
                    <td class="text-center no-border-bottom">${it.qty}</td>
                    <td class="text-right no-border-bottom">${Number(it.rate).toFixed(2)}</td>
                    <td class="text-center no-border-bottom">No.</td>
                    <td class="text-right font-bold no-border-bottom">${baseAmt.toFixed(2)}</td>
                 </tr>
                 ${taxRows}`;
             }).join('')}
             <tr><td class="no-border-top text-center" style="height: 5px;"></td><td class="no-border-top"></td><td class="no-border-top"></td><td class="no-border-top"></td><td class="no-border-top"></td><td class="no-border-top"></td><td class="no-border-top"></td></tr>
             <tr><td colspan="3" class="text-right font-bold">Total</td><td class="text-center font-bold">${items.reduce((a,c)=>a+Number(c.qty),0)}</td><td colspan="2"></td><td class="text-right font-bold" style="font-size: 14px;">₹${grandTotal.toFixed(2)}</td></tr>
          </table>

          <table>
             <tr>
                <td style="width: 80%; border-right: none;">Amount Chargeable (in words)<br/><strong style="font-size: 13px;">INR ${numberToWords(grandTotal)} Only</strong></td>
                <td class="text-right" style="width: 20%; border-left: none; font-style: italic;">E. & O.E</td>
             </tr>
          </table>

          <table style="border-bottom:none;">
             <tr><td colspan="6" style="border-bottom:none; padding-bottom:2px;">
                Tax Amount (in words) : <strong>INR ${numberToWords(totalCGST + totalSGST + totalIGST)} Only</strong><br/>
                Company's PAN : <strong>${company.pan || 'AAZFD1290J'}</strong><br/>
                <u style="font-size: 11px;">Declaration</u><br/>
                <span style="font-size: 10px;">We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. Subject to Jaipur Jurisdiction only.</span>
             </td></tr>
          </table>
          <table style="border-top:none;">
             <tr>
                <td style="width: 50%; border-top:none; border-right:none;">
                   Company's Bank Details<br/>
                   Bank Name : <strong>${company.bank_name || 'IndusInd Bank'}</strong><br/>
                   A/c No. : <strong>${company.acc_no || '258107044926'}</strong><br/>
                   Branch & IFSC : <strong>${company.ifsc || 'INDB0000593'}</strong>
                </td>
                <td style="width: 50%; border-top:none; border-left:none; text-align: right; padding-top: 5px;">
                   <div class="font-bold mb-4">for ${company.name || 'DIGITAL SMART TECHNOLOGY'}</div><br/>
                   <div>Authorised Signatory</div>
                </td>
             </tr>
          </table>
       </div>
    </body>
    </html>
    `;
    printWin.document.write(html);
    printWin.document.close();
    setTimeout(() => { printWin.print(); }, 800);
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Manage Invoices</h1>
        <Link to="/invoices/new" className="bg-emerald-600 text-white px-4 py-2 rounded shadow font-bold">+ Create New</Link>
      </div>
      <div className="bg-white shadow rounded-lg p-4 overflow-x-auto">
         <table className="min-w-full text-left">
           <thead>
             <tr className="border-b-2 text-gray-600 uppercase text-sm">
               <th className="p-3">Date</th><th className="p-3">Inv No.</th><th className="p-3">Client</th><th className="p-3">Amount</th><th className="p-3 text-center">Actions</th>
             </tr>
           </thead>
           <tbody>
             {invoices.length === 0 && <tr><td colSpan="5" className="text-center p-4 text-gray-500">No invoices generated yet.</td></tr>}
             {invoices.map(inv => {
                const cust = customers.find(c => c.id == inv.customer_id) || {};
                return (
                  <tr key={inv.id} className="border-b hover:bg-gray-50">
                    <td className="p-3">{inv.date}</td>
                    <td className="p-3 font-bold">{inv.invoice_no}</td>
                    <td className="p-3">{cust.name}</td>
                    <td className="p-3 font-bold text-green-700">₹{Number(inv.total).toFixed(2)}</td>
                    <td className="p-3 flex justify-center gap-2">
                       <button onClick={() => handlePrint(inv)} className="bg-blue-100 text-blue-700 px-3 py-1 rounded text-sm font-bold hover:bg-blue-200">🖨️ PDF</button>
                       <button onClick={() => navigate(`/invoices/edit/${inv.id}`)} className="bg-orange-100 text-orange-700 px-3 py-1 rounded text-sm font-bold hover:bg-orange-200">✏️ Edit</button>
                       <button onClick={() => handleDelete(inv.id)} className="bg-red-100 text-red-700 px-3 py-1 rounded text-sm font-bold hover:bg-red-200">🗑️ Del</button>
                    </td>
                  </tr>
                )
             })}
           </tbody>
         </table>
      </div>
    </div>
  );
}
